module.exports = __webpack_public_path__ + "static/esco-1-2601614689e48e1e39c8db8cce27ca06.jpeg";